import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'hooks/useTranslation';
import { useAuthRouteDataContext } from 'providers/AuthRouteDataProvider/AuthRouteDataProvider.context';
import { getPhoneMaxLengthByCountry } from 'utils/getPhoneMaxLength';
import {
  BKJAddressInput,
  BKJTextInput,
  BKJPhoneNumberInput,
} from '@bookjane2/bookjane-design-library';
import {
  ContactInformationTitle,
  FieldColumn,
  FieldRow,
  LocationFieldsWrapper,
} from 'pages/Settings/pages/LocationSettings/CustomersSettingsPage/CustomersSettingsPage.styled';
import { ChangeFunctionType } from '@bookjane2/bookjane-design-library/lib/common.types';
import { FormValuesType } from 'types/common.types';

interface LocationFormFieldsProps {
  location: FormValuesType;
  onLocationChange: ChangeFunctionType;
}

export const LocationFormFields: FC<LocationFormFieldsProps> = ({ location, onLocationChange }) => {
  const { t } = useTranslation();
  const { locationId } = useParams<{ locationId: string }>();
  const { locationFilter } = useAuthRouteDataContext();
  const locationFromDropdownData = locationFilter.data?.find(
    (loc) => loc.id === locationId || loc.value === locationId,
  );

  return (
    <LocationFieldsWrapper>
      <BKJTextInput
        label={`${t('location_settings:LOCATION_NAME')}*`}
        name="name"
        value={location.name}
        onChange={onLocationChange}
      />

      <FieldRow>
        <FieldColumn flex={2}>
          <BKJAddressInput
            label={`${t('location_settings:ADDRESS')}*`}
            name="address"
            value={location.address}
            onChange={onLocationChange}
            placeholder="Location Address"
          />
        </FieldColumn>
        <FieldColumn flex={1}>
          <BKJTextInput
            label={t('location_settings:SUITE_UNIT_NO')}
            name="unitNo"
            value={location.unitNo || ''}
            onChange={onLocationChange}
          />
        </FieldColumn>
      </FieldRow>

      <ContactInformationTitle>
        {t('location_settings:CONTACT_INFORMATION')}
      </ContactInformationTitle>

      <BKJTextInput
        label={t('location_settings:FULL_NAME')}
        name="contactName"
        value={location.contactName}
        onChange={onLocationChange}
      />

      <FieldRow>
        <FieldColumn flex={1}>
          <BKJTextInput
            label={t('location_settings:EMAIL')}
            name="contactEmail"
            value={location.contactEmail}
            onChange={onLocationChange}
          />
        </FieldColumn>
        <FieldColumn flex={1}>
          <BKJPhoneNumberInput
            label={t('location_settings:PHONE_NUMBER')}
            name="contactPhone"
            value={location.contactPhone}
            onChange={onLocationChange}
            maxLength={getPhoneMaxLengthByCountry(locationFromDropdownData?.country)}
          />
        </FieldColumn>
      </FieldRow>
    </LocationFieldsWrapper>
  );
};
